export enum DataSectionClickActions {
  ADD_COLLECTION = 'add_collection',
  ADD_DATASET = 'add_dataset',
  ADD_FORM_DATASET = 'add_form_dataset',
  ADD_RICHCONTENT = 'add_richcontent',
  ADD_PRESET = 'add_preset',
  ADD_DP_DATASET = 'add_dp_dataset',
  INSTALL_APP_AND_NOTIFY = 'install_app_and_notify',
}
